import React, { useState } from 'react'
import styles from 'components/Navigation/Navigation.module.css'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ReactComponent as VislineLogoIcon } from 'assets/logos/logo.svg'
import { ReactComponent as VislineLogotypeIcon } from 'assets/logos/visline.svg'
import { NotificationMenuSwitch } from 'components/Notification'
import {IntegrationInfoField, LanguageSelectField} from 'components/Navigation'
import { ReactComponent as OpenIcon } from 'assets/icons/right.svg'
import { ReactComponent as CloseIcon } from 'assets/icons/left.svg'
import { backgroundColor, primaryRed } from 'styles/variables'
import {
  getNavigationExpandedFromLocalStorage,
  setNavigationExpandedInLocalStorage
} from 'components/Navigation/preferences'
import { NavigationList } from 'components/Navigation/NavigationList'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    display: 'flex',
    zIndex: 1200,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(
      ['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
  },
  appBarShift: {
    marginLeft: drawerWidth => drawerWidth,
    width: drawerWidth => `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(
      ['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
  },
  hide: {
    display: 'none',
  },
  docked: {
    overflowX: 'inherit',
  },
  paper: {
    overflow: 'inherit',
    '&:hover $expandCollapseIcon': {
      visibility: 'visible',
      opacity: 1,
      transition: 'opacity 0.3s, visibility 0.3s'
    }
  },
  drawer: {
    position: 'relative',
    width: drawerWidth => drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth => drawerWidth,
    transition: theme.transitions.create(
      'width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '90px',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(
      0, 1), ...theme.mixins.toolbar,
  },
  content: {
    overflowX: 'hidden'
  },
  expandCollapseIcon: {
    position: 'absolute',
    right: '-10px',
    border: '1px solid',
    borderRadius: '50%',
    borderColor: primaryRed,
    backgroundColor: backgroundColor,
    cursor: 'pointer',
    width: 20,
    height: 20,
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity 0.3s, visibility 0.3s'
  }
}))

export function Navigation ({ width, open, setOpen }) {
  const classes = useStyles(width)
  const [notificationListOpen, setNotificationListOpen] = useState(false)

  const handleDrawerOpen = () => {
    setOpen(true)
    setNavigationExpandedInLocalStorage(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
    setNotificationListOpen(false)
    setNavigationExpandedInLocalStorage(false)
  }

  const handleNotificationOpen = () => {
    setOpen(true)
    setNotificationListOpen(true)
  }

  const handleNotificationClose = () => {
    setOpen(getNavigationExpandedFromLocalStorage())
    setNotificationListOpen(false)
  }

  return (<div className={classes.root}>
      <CssBaseline/>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open
        })}
        classes={{
          paper: clsx(classes.paper, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open
          }),
          docked: clsx(classes.docked)
        }}
      >
        <div className={classes.content}>
          <div className={classes.toolbar}>
            <div className={open ? styles.logoBoxOpen : styles.logoBoxClosed}>
              <div className={open ? styles.logotypeOpen : styles.logotypeClosed}>
                <VislineLogotypeIcon/>
              </div>
              <div className={styles.logo}>
                <VislineLogoIcon/>
              </div>
            </div>
          </div>
          {open ?
            <CloseIcon className={classes.expandCollapseIcon}
                       onClick={handleDrawerClose}/> :
            <OpenIcon className={classes.expandCollapseIcon}
                      onClick={handleDrawerOpen}/>}
          <NotificationMenuSwitch
            openNotifications={handleNotificationOpen}
            closeNotifications={handleNotificationClose}
            notificationsOpen={notificationListOpen}/>
          <NavigationList notificationListOpen={notificationListOpen}/>
        </div>
        <div className='my-auto'/>
        <IntegrationInfoField drawerOpen={open}/>
        <LanguageSelectField/>
      </Drawer>
    </div>
  )
}


